/*
 * Backpack - Skyscanner's Design System
 *
 * Copyright 2016 Skyscanner Ltd
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { cssModules, getDataComponentAttribute } from "../../bpk-react-utils";
import STYLES from "./BpkVisuallyHidden.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
const getClassName = cssModules(STYLES);
const BpkVisuallyHidden = ({
  as: Element = 'span',
  children
}) => {
  const classNames = getClassName('bpk-visually-hidden');
  return (
    /*#__PURE__*/
    // Allowed, Element is always a dom element.
    // eslint-disable-next-line @skyscanner/rules/forbid-component-props
    _jsx(Element, {
      className: classNames,
      ...getDataComponentAttribute('VisuallyHidden'),
      children: children
    })
  );
};
export default BpkVisuallyHidden;